import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-outdated-web-app flex middle-xs center-xs"
}
const _hoisted_2 = { class: "box start-xs" }
const _hoisted_3 = { class: "bold black" }
const _hoisted_4 = { class: "regular black" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "— FinalPrice", -1)

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { Configurator } from '@/types';
  import { BaseUrls } from '@/api/module/baseUrl';
  import ButtonComponent from './ButtonComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppOutdatedPlaceholder',
  setup(__props) {

  const { t } = useI18n();
  const store = useStore();

  const EVENTS = ['load', 'visibilitychange'];
  const configurator = ref<Configurator.State | null>(null);
  const isShown = ref<boolean>(false);

  const ignoreVersionsMismatch = computed(() => {
    return (
      configurator.value != null &&
      configurator.value.hostModule.ignoreVersionsMismatch
    );
  });

  function forceUpdate() {
    window.location.reload();
  }

  function compareVersions(v1: string, v2: string) {
    const parts1 = v1.split('.').map(Number);
    const parts2 = v2.split('.').map(Number);

    const maxLength = Math.max(parts1.length, parts2.length);

    for (let i = 0; i < maxLength; i++) {
      const num1 = parts1[i] || 0;
      const num2 = parts2[i] || 0;

      if (num1 > num2) return 1;
      if (num1 < num2) return -1;
    }

    return 0;
  }

  function checkActualVersion() {
    const current = process.env.VERSION;
    if (document.hidden || !current) {
      return;
    }

    fetch(`${BaseUrls.mlApiUrl}/api/web-app`)
      .then(res => {
        return res.json();
      })
      .then(relevant => {
        store.commit('support/setVersions', { relevant, current });
        return compareVersions(current, relevant);
      })
      .then(value => {
        isShown.value = value === -1;
      });
  }

  onMounted(() => {
    EVENTS.forEach(event => window.addEventListener(event, checkActualVersion));

    configurator.value = Configurator.builder();
  });

  onBeforeUnmount(() => {
    EVENTS.forEach(event =>
      window.removeEventListener(event, checkActualVersion),
    );
  });

return (_ctx: any,_cache: any) => {
  return (isShown.value && !_unref(ignoreVersionsMismatch))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('appOutdated.title')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('appOutdated.subtitle')), 1),
            _createElementVNode("div", null, [
              _createVNode(ButtonComponent, {
                variant: "primary",
                height: "42px",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (forceUpdate()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('appOutdated.update')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_5,
            _hoisted_6
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})